import { Component } from 'san';
import * as _ from 'lodash';

import { dateFormat } from 'src/filters';
import { IChildrenProjectsParams, IProject } from 'src/models';
import { ROOT_PROJECT_ID } from 'src/consts';

import Light from 'src/components/Light/Light';

import uiService from 'src/services/ui.service';
import projectService from 'src/services/project.service';
import permissionService from 'src/services/permission.service';
import dialogService from 'src/services/dialog.service';
import { EProjectItemType, ESearchMode } from 'src/enums';

const LEVEL_OFFSET = 24; // 计划标题每层级的缩进量（px）

export default class ProjectsList extends Component {
    constructor(options: any) {
        super(options);
    }

    static components = {
        'ui-light': Light,
    };

    static filters = {
        dateFormat,
    };

    static computed = {
        snColWidth() {
            return uiService.getSnColWidth(this.data.get('projects'));
        },
        checkedProjects() {
            const projects = this.data.get('projects');
            return _.filter(projects, { _is_checked: true });
        },
        // isCheckedAll() {
        //     const projects = this.data.get('projects');
        //     const checkedProjects = _.filter(projects, { _is_checked: true });
        //     return checkedProjects.length > 0 && checkedProjects.length === projects.length;
        // }
    };

    initData() {
        return {
            projects: [], // {==}
            params: null, // {{}} 项目列表的筛选参数，在此用户获取子项目时传参
            deletePermission: false, // 有“删除”权限
            enableCheck: false, //{{}} 显示checkbox，不显示“关注”、“删除”列
            projectItemTypeEnum: EProjectItemType,
            searchMode: ESearchMode.Default, // 搜索模式：简约模式/完整树模式
        };
    }

    inited() {
        this.getDeletePermission();
    }

    getDeletePermission() {
        permissionService
            .getCurrentCertainPermissionOptionValue('批量删除')
            .then((hasPermission) => {
                this.data.set('deletePermission', hasPermission);
            });
    }

    // 计算标题缩进量
    getTitleLeftOffset(project: IProject): string {
        return project.id_level ? 'width:' + (project.id_level - 1) * LEVEL_OFFSET + 'px' : '';
    }

    // 获取关注按钮样式
    // getFollowClass(project: IProject): string {
    //     return project.is_follow ? 'blue' : 'black';
    // }

    //  收展子项目列表
    scalingSubProjects(project: IProject) {
        if (project._is_busy) {
            return;
        }
        project._is_busy = true;
        const projects: IProject[] = this.data.get('projects');
        const indexOfProject = _.findIndex(projects, {
            id: project.id
        });
        if (project._is_expand) {
            const subList = _.filter(projects, (item) => {
                return item._sn.startsWith(project._sn + '.');
            });
            this.data.splice('projects', [indexOfProject + 1, subList.length]); // 删除子项目
            project._is_expand = false;
            project._is_busy = false;
            this.data.splice('projects', [indexOfProject, 1, project]);
        } else {
            const params: IChildrenProjectsParams = _.cloneDeep(this.data.get('params'));
            params.puid = project.puid;
            params.item_type = project.item_type;
            const isLevelOne = ROOT_PROJECT_ID === project.parent_id;
            const searchMode = this.data.get('searchMode');
            projectService.getProjectCenterChildrenProjects(project.id, project.matched_project_ids, params, searchMode, isLevelOne).then((children) => {
                project._is_expand = true;
                project._is_busy = false;
                this.data.splice('projects', [indexOfProject, 1, project]);
                _.forEach(children, (item, index) => {
                    item._sn = project._sn + '.' + (index + 1);
                });
                this.data.splice('projects', [indexOfProject + 1, 0, ...children]);
            });
        }
    }

    // 关注
    toggleFollow(project: IProject) {
        const projects: IProject[] = this.data.get('projects');
        const indexOfProject = _.findIndex(projects, {
            id: project.id,
        });
        (project.is_follow
            ? projectService.unfollowProject(project.id)
            : projectService.followProject(project.id)
        ).then(() => {
            project.is_follow = !project.is_follow;
            this.data.splice('projects', [indexOfProject, 1, project]);
        });
    }

    toDelete(project: IProject) {
        dialogService.show({
            title: '提示',
            content: `您确定要删除『 ${project.title} 』项目吗？`,
            confirmCallback: () => {
                this.delete(project);
            },
        });
    }
    delete(project: IProject) {
        projectService.deleteProject(project.id, project.item_type).then(() => {
            this.fire('delete-project', project);
        });
    }

    goToDetail(project: IProject) {
        projectService.saveProjectReadMarkSync(project);
        // 点击链接时，打开新页面，不需要记录展开的项目树
        // this.recordExpandTreeSync(project);
        const href =
            EProjectItemType.Schedule === project.item_type
                ? `/audits/schedule/${project.puid}`
                : `/projects/${project.puid}`;
        window.open(href);
    }

    // 记录展开的项目树
    private recordExpandTreeSync(project: IProject) {
        const projects: IProject[] = this.data.get('projects');
        const projectIds: string[] = [];
        function recordProject(projectId: string) {
            projectIds.unshift(projectId);
            const currentProject = _.find(projects, { id: projectId });
            if (currentProject.parent_id && ROOT_PROJECT_ID !== currentProject.parent_id) {
                recordProject(currentProject.parent_id);
            }
        }
        recordProject(project.id);
        this.dispatch('UI:project-list-visit-change', projectIds);
    }

    // toggleCheckAll() {
    //     const isCheckedAll: boolean = !this.data.get('isCheckedAll');
    //     isCheckedAll ? this.checkAll() : this.unCheckAll();
    // }
    // private checkAll() {
    //     const projects: IProject[] = this.data.get('projects');
    //     _.forEach(projects, project => {
    //         project._is_checked = true;
    //     });
    //     this.data.splice('projects', [0, projects.length, ...projects]);
    // }
    // private unCheckAll() {
    //     const projects: IProject[] = this.data.get('projects');
    //     _.forEach(projects, project => {
    //         project._is_checked = false;
    //     });
    //     this.data.splice('projects', [0, projects.length, ...projects]);
    // }
    checkProject(project: IProject) {
        const projects: IProject[] = this.data.get('projects');
        const index: number = _.findIndex(projects, { id: project.id });
        project._is_checked = !project._is_checked;
        this.data.splice('projects', [index, 1, project]);
    }
}
